import { Navigate } from "react-router-dom";
import { LOCALSTORAGEAUTHUSERINFO } from "../constants/local-storage-constant";
import { getDataFromLocalStorage } from "../utils/views-utils";

export const SalesRoute: React.FC<any> = (props: any) => {
  // const { auth } = useAppSelector((state) => state);
  const auth = getDataFromLocalStorage(LOCALSTORAGEAUTHUSERINFO);

  return !auth?.token ? <>{props.children}</> : <Navigate to="/" />;
  // uncomment it if backend does not work
  // return <>{props.children}</>
};
